// extracted by mini-css-extract-plugin
export var container = "_65-0";
export var infoButton = "_65-1";
export var label = "_65-3";
export var labelExpanded = "_65-4";
export var price = "_65-5";
export var priceExpanded = "_65-6";
export var title = "_65-2";